import ExtensionVersionAEPSwift from "../../../../src/pages/documentation/profile/tabs/migration/extension-version/aep-swift.md";
import ExtensionVersionAEPObjectiveC from "../../../../src/pages/documentation/profile/tabs/migration/extension-version/aep-objective-c.md";
import ExtensionVersionACPObjectiveC from "../../../../src/pages/documentation/profile/tabs/migration/extension-version/acp-objective-c.md";
import UpdateUserAttributesAEPSwift from "../../../../src/pages/documentation/profile/tabs/migration/update-user-attributes/aep-swift.md";
import UpdateUserAttributesAEPObjectiveC from "../../../../src/pages/documentation/profile/tabs/migration/update-user-attributes/aep-objective-c.md";
import UpdateUserAttributesACPObjectiveC from "../../../../src/pages/documentation/profile/tabs/migration/update-user-attributes/acp-objective-c.md";
import RemoveUserAttributeAEPSwift from "../../../../src/pages/documentation/profile/tabs/migration/remove-user-attribute/aep-swift.md";
import RemoveUserAttributeAEPObjectiveC from "../../../../src/pages/documentation/profile/tabs/migration/remove-user-attribute/aep-objective-c.md";
import RemoveUserAttributeACPObjectiveC from "../../../../src/pages/documentation/profile/tabs/migration/remove-user-attribute/acp-objective-c.md";
import GetUserAttributesAEPSwift from "../../../../src/pages/documentation/profile/tabs/migration/get-user-attributes/aep-swift.md";
import GetUserAttributesAEPObjectiveC from "../../../../src/pages/documentation/profile/tabs/migration/get-user-attributes/aep-objective-c.md";
import GetUserAttributesACPObjectiveC from "../../../../src/pages/documentation/profile/tabs/migration/get-user-attributes/acp-objective-c.md";
import * as React from 'react';
export default {
  ExtensionVersionAEPSwift,
  ExtensionVersionAEPObjectiveC,
  ExtensionVersionACPObjectiveC,
  UpdateUserAttributesAEPSwift,
  UpdateUserAttributesAEPObjectiveC,
  UpdateUserAttributesACPObjectiveC,
  RemoveUserAttributeAEPSwift,
  RemoveUserAttributeAEPObjectiveC,
  RemoveUserAttributeACPObjectiveC,
  GetUserAttributesAEPSwift,
  GetUserAttributesAEPObjectiveC,
  GetUserAttributesACPObjectiveC,
  React
};